import apiClient from "../apiClient";
import useApiWrapper from "../apiWrapper";

// Generalized function to build query parameters for a URL
const buildUrl = (baseUrl, filters) => {
    const { pageNo, pageSize, query, search, sorting, status, attendanceId, Id, dropdown, employee_id, template_id } = filters;
    const params = [];

    if (pageNo) params.push(`page_no=${pageNo}`);
    if (pageSize) params.push(`page_size=${pageSize}`);
    if (query) params.push(query);
    if (search) params.push(`search=${search}`);
    if (sorting) params.push(sorting);
    if (status) params.push(`status=${status}`);
    if (attendanceId) params.push(`attendance_id=${attendanceId}`);
    if (Id) params.push(`id=${Id}`);
    if (dropdown) params.push(`drop_down=${true}`);
    if (employee_id) params.push(`employee_id=${employee_id}`)
    if (template_id) params.push(`template_id=${template_id}`)

    return params.length > 0 ? `${baseUrl}?${params.join("&")}` : baseUrl;
};

const useApiMethods = () => {
    const { apiWrapper } = useApiWrapper();

    const fetch = (url, filters = {}, setLoading) => {
        const URL = buildUrl(`/${url}`, filters);
        return apiWrapper(() => apiClient.get(URL), setLoading);
    };

    const create = (url, data, isFormData = false, setLoading) => {
        const headers = isFormData ? { 'Content-Type': 'multipart/form-data' } : { 'Content-Type': 'application/json' };
        return apiWrapper(() => apiClient.post(url, data, { headers }), setLoading);
    };

    const update = (url, data, isFormData = false, setLoading) => {
        const headers = isFormData ? { 'Content-Type': 'multipart/form-data' } : { 'Content-Type': 'application/json' };
        return apiWrapper(() => apiClient.put(url, data, { headers }), setLoading);
    };

    const remove = (url, setLoading) => {
        return apiWrapper(() => apiClient.delete(url), setLoading);
    };

    const ApiMethods = {
        fetch,
        create,
        update,
        remove
    };

    return ApiMethods;
};

export default useApiMethods;
